import { gql } from '@apollo/client'

export const GET_AUCTION_FILTER_DATA = gql`
  query ListAuctionFilterData($input: oListSetMetaDataInput!) {
    listAuctionFilterData(input: $input) {
      aAuctionPlayerCountry {
        sTitle
        sAbbr
        _id
      }
      aAuctionPlayerTeam {
        oTeam {
          _id
          sTitle
          sAbbr
        }
      }
    }
  }
`
